// @flow

class ContactUs {

    constructor(args) {
        this.city = (args || {}).city || "";
        this.notes = (args || {}).notes || "";
        this.state = (args || {}).state || "";
        this.street = (args || {}).street || "";
        this.street2 = args.street2 || "";
        this.zip = args.zip || "";
        this.phoneNumber = args.phoneNumber || "";
    }

    static create(args = {}) {
        return new ContactUs(args);
    }
}

export default class EventInfo {
    name: ?string;
    description: ?string;
    eventDate: ?string;
    created: ?Date;
    contactUs: ?ContactUs;
    eventWindowStart: Date;
    eventWindowEnd: Date;

    constructor(args: ?Object = {}) {
        this.contactUs = ContactUs.create(args.contactUs);
        this.description = args.description || "";
        this.name = args.name || "";
        this.eventDate = args.eventDate || "";
        this.eventWindowStart = args.eventWindowStart || "";
        this.eventWindowEnd = args.eventWindowEnd || "";
    }

    static create(args: Object = {}) {
        return JSON.parse(JSON.stringify(new EventInfo(args)));
    }
}
